import { Colors } from '@factorialco/deprecated-design-system'

import { formatGraphTimeTitle } from 'modules/project_management/lib/formatChartComponents'

export type BreakdownTransformedDataId = 'fixed_cost' | 'labor_cost' | 'spending_cost'

export type BreakdownTransformedData = {
  id: BreakdownTransformedDataId
  label: string
  max: number
  min: number
  data: BreakdownGraphData[]
  color: Colors
}

export type BreakdownGraphData = {
  x: number
  y: number
  title: string
}

export type ProjectTimeGraph = {
  year: string
  timeSlot: string
  costCents?: number | null | undefined
}

export const getCostBreakdownTransformedData = (
  data: string[],
  id: BreakdownTransformedDataId,
  label: string,
  color: Colors,
  selectedFrequency: string
) => {
  const formattedCostPoints =
    data.map((costString: string) => {
      const validJsonString = costString.replace(/=>/g, ':')
      const parsedObject = JSON.parse(validJsonString)
      return {
        year: parsedObject.year,
        timeSlot: parsedObject.time_slot,
        costCents: parsedObject.cost_cents,
      }
    }) || []

  const transformedData = formattedCostPoints.map((item, index) => {
    return {
      x: index,
      y: item.costCents ? item.costCents / 100 : 0,
      title: index !== 0 ? formatGraphTimeTitle(item.year, item.timeSlot, selectedFrequency) : '',
    }
  })

  const registeredData: BreakdownTransformedData = {
    id,
    label,
    min: formattedCostPoints.at(0)?.costCents / 100 || 0,
    max: formattedCostPoints.at(-1)?.costCents / 100 || 0,
    data: transformedData,
    color,
  }

  return registeredData
}
